import { ResumeEducation } from '../../types';
import { Plus, X } from 'lucide-react';

interface EducationSectionProps {
    education: ResumeEducation[];
    onChange: (education: ResumeEducation[]) => void;
}

export function EducationSection({ education, onChange }: EducationSectionProps) {
    const addEducation = () => {
        onChange([
            ...education,
            {
                id: Date.now().toString(),
                institution: '',
                degree: '',
            },
        ]);
    };

    const removeEducation = (index: number) => {
        onChange(education.filter((_, i) => i !== index));
    };

    const updateEducation = (index: number, field: keyof ResumeEducation, value: any) => {
        const newEducation = [...education];
        newEducation[index] = { ...newEducation[index], [field]: value };
        onChange(newEducation);
    };

    return (
        <div className="card">
            <div className="flex justify-between items-center mb-4">
                <h2 className="section-title mb-0">Education</h2>
                <button onClick={addEducation} className="btn btn-secondary text-sm flex items-center gap-1">
                    <Plus size={16} />
                    Add Education
                </button>
            </div>

            <div className="space-y-4">
                {education.map((edu, index) => (
                    <div key={edu.id} className="border border-gray-200 rounded-lg p-4 relative">
                        <button
                            onClick={() => removeEducation(index)}
                            className="absolute top-2 right-2 text-red-600 hover:text-red-700"
                        >
                            <X size={20} />
                        </button>

                        <div className="space-y-3">
                            <div>
                                <label className="label">Institution *</label>
                                <input
                                    type="text"
                                    value={edu.institution}
                                    onChange={(e) => updateEducation(index, 'institution', e.target.value)}
                                    className="input"
                                    placeholder="University of California"
                                />
                            </div>

                            <div className="grid grid-cols-2 gap-3">
                                <div>
                                    <label className="label">Degree *</label>
                                    <input
                                        type="text"
                                        value={edu.degree}
                                        onChange={(e) => updateEducation(index, 'degree', e.target.value)}
                                        className="input"
                                        placeholder="Bachelor of Science"
                                    />
                                </div>
                                <div>
                                    <label className="label">Field of Study</label>
                                    <input
                                        type="text"
                                        value={edu.field || ''}
                                        onChange={(e) => updateEducation(index, 'field', e.target.value)}
                                        className="input"
                                        placeholder="Computer Science"
                                    />
                                </div>
                            </div>

                            <div className="grid grid-cols-3 gap-3">
                                <div>
                                    <label className="label">Location</label>
                                    <input
                                        type="text"
                                        value={edu.location || ''}
                                        onChange={(e) => updateEducation(index, 'location', e.target.value)}
                                        className="input"
                                        placeholder="Berkeley, CA"
                                    />
                                </div>
                                <div>
                                    <label className="label">Graduation Date</label>
                                    <input
                                        type="text" inputMode="numeric" pattern="[0-9]{4}-[0-9]{2}"
                                        placeholder="YYYY-MM"
                                        value={edu.graduationDate || ''}
                                        onChange={(e) => updateEducation(index, 'graduationDate', e.target.value)}
                                        className="input"
                                    />
                                </div>
                                <div>
                                    <label className="label">GPA</label>
                                    <input
                                        type="text"
                                        value={edu.gpa || ''}
                                        onChange={(e) => updateEducation(index, 'gpa', e.target.value)}
                                        className="input"
                                        placeholder="3.8"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                ))}

                {education.length === 0 && (
                    <p className="text-gray-500 text-center py-4">No education added yet</p>
                )}
            </div>
        </div>
    );
}



